

































































import LazyHydrate from 'vue-lazy-hydration'
import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { mdiInformationOutline, mdiTune } from '@mdi/js'
import { VPopover } from 'v-tooltip'
import { ICatalogFilterItem } from '~/assets/interfaces/catalog'
import { declension } from '~/assets/functions/declension'
import '~/assets/scss/v-tooltip.scss'
import { filterUrl } from '~/assets/filters/url'

@Component({
  components: {
    LazyHydrate,
    ComponentCatalogFilterRange: () =>
      import('~/components/catalog/filter/catalog-filter-range.vue'),
    ComponentCatalogFilterCheckbox: () =>
      import('~/components/catalog/filter/catalog-filter-checkbox.vue'),
    ComponentFormButtonIcon: () => import('~/components/form/button-icon.vue'),
    ComponentFormButton: () => import('~/components/form/button.vue'),
    ComponentIcon: () => import('~/components/icon/icon.vue'),
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentCatalogFilterImage: () =>
      import('~/components/catalog/filter/catalog-filter-image.vue'),
    VPopover,
    ComponentCatalogFilterInfo: () =>
      import('~/components/catalog/filter/catalog-filter-info.vue'),
  },
  filters: {
    filterDeclension(number: number) {
      return (
        'Показать ' +
        number.toLocaleString() +
        ' ' +
        declension(number, ['товар', 'товара', 'товаров'])
      )
    },
  },
})
export default class ComponentMobileCatalogFilter extends Vue {
  @Prop({ default: false, type: Boolean }) private loading!: boolean
  @Prop({ type: Array, default: () => [] }) items!: ICatalogFilterItem[]
  @Prop({ type: Number, default: 0 }) amount!: number
  private mdiTune = mdiTune

  private icons = {
    mdiInformationOutline,
  }

  private changeHandler(key: string, typeParam: string, e: any) {
    let newE = ''
    if (typeParam === 'range') {
      newE = e.min + ':' + e.max
    }
    if (typeParam === 'checkbox' || typeParam === 'image') {
      newE = e.join(';')
    }
    const query = { ...this.$route.query }
    query[key] = newE
    if (query.page) {
      query.page = '1'
    }
    this.$router.push({
      path: filterUrl(this.$route.path),
      query,
    })
  }

  private isOpen = false

  private mounted(): void {
    this.$emit('loaded')
  }
}
